function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M298,97.3H44.4c-4.2,0-7.6-3.4-7.6-7.6V75.5c0-4.2,3.4-7.6,7.6-7.6H298c4.2,0,7.6,3.4,7.6,7.6v14.2 C305.7,93.9,302.3,97.3,298,97.3z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#DDDDDD",
  d: "M122.6,85.9H49.2c-1.8,0-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3h73.4c1.8,0,3.3,1.5,3.3,3.3 C125.9,84.4,124.4,85.9,122.6,85.9z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M298,58.5H44.4c-4.2,0-7.6-3.4-7.6-7.6V36.7c0-4.2,3.4-7.6,7.6-7.6H298c4.2,0,7.6,3.4,7.6,7.6v14.2 C305.7,55.1,302.3,58.5,298,58.5z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#DDDDDD",
  d: "M122.6,47H49.2c-1.8,0-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3h73.4c1.8,0,3.3,1.5,3.3,3.3 C125.9,45.6,124.4,47,122.6,47z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M298,136.1H44.4c-4.2,0-7.6-3.4-7.6-7.6v-14.2c0-4.2,3.4-7.6,7.6-7.6H298c4.2,0,7.6,3.4,7.6,7.6v14.2 C305.7,132.7,302.3,136.1,298,136.1z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#DDDDDD",
  d: "M122.6,124.7H49.2c-1.8,0-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3h73.4c1.8,0,3.3,1.5,3.3,3.3 C125.9,123.2,124.4,124.7,122.6,124.7z"
});

var _ref8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#DDDDDD",
  d: "M293.7,50.9c-0.5,0-1-0.2-1.4-0.6L282,40c-0.8-0.8-0.8-2,0-2.8s2-0.8,2.8,0l10.3,10.3c0.8,0.8,0.8,2,0,2.8 C294.7,50.7,294.2,50.9,293.7,50.9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DDDDDD",
  d: "M283.4,50.9c-0.5,0-1-0.2-1.4-0.6c-0.8-0.8-0.8-2,0-2.8l10.3-10.3c0.8-0.8,2-0.8,2.8,0s0.8,2,0,2.8l-10.3,10.3 C284.4,50.7,283.9,50.9,283.4,50.9z"
}));

var _ref9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#DDDDDD",
  d: "M293.7,89.7c-0.5,0-1-0.2-1.4-0.6L282,78.9c-0.8-0.8-0.8-2,0-2.8s2-0.8,2.8,0l10.3,10.3c0.8,0.8,0.8,2,0,2.8 C294.7,89.5,294.2,89.7,293.7,89.7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DDDDDD",
  d: "M283.4,89.7c-0.5,0-1-0.2-1.4-0.6c-0.8-0.8-0.8-2,0-2.8L292.3,76c0.8-0.8,2-0.8,2.8,0s0.8,2,0,2.8l-10.3,10.3 C284.4,89.5,283.9,89.7,283.4,89.7z"
}));

var _ref10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#DDDDDD",
  d: "M293.7,128.6c-0.5,0-1-0.2-1.4-0.6L282,117.7c-0.8-0.8-0.8-2,0-2.8s2-0.8,2.8,0l10.3,10.3c0.8,0.8,0.8,2,0,2.8 C294.7,128.4,294.2,128.6,293.7,128.6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DDDDDD",
  d: "M283.4,128.6c-0.5,0-1-0.2-1.4-0.6c-0.8-0.8-0.8-2,0-2.8l10.3-10.3c0.8-0.8,2-0.8,2.8,0s0.8,2,0,2.8L284.8,128 C284.4,128.4,283.9,128.6,283.4,128.6z"
}));

function SvgNoReadyGroupsWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 342.4 164.6",
    style: {
      enableBackground: "new 0 0 342.4 164.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoReadyGroupsWhite);
export default __webpack_public_path__ + "static/media/no-ready-groups-white.f113f8b0.svg";
export { ForwardRef as ReactComponent };